export default {
      id: "player-play.sprite-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#player-play.sprite-usage",
      toString: function () {
        return this.url;
      }
    }